import React, { useState, useEffect } from 'react';
import notify from './utils/notify';
import { useParams, useNavigate } from 'react-router-dom';
import './Groups.css';
import { useApi } from './useApi';

function Groups() {
    const { tournamentId } = useParams();
    const navigate = useNavigate();
    const { authenticatedFetch } = useApi();
    const [tournament, setTournament] = useState(null);
    const [groups, setGroups] = useState([]);
    const [ungroupedPlayers, setUngroupedPlayers] = useState([]);
    const [selectedRound, setSelectedRound] = useState(1);
    const [openSections, setOpenSections] = useState({ players: true, groups: true });

    const fetchTournamentAndGroups = async () => {
        try {
            const tRes = await authenticatedFetch(`/tournaments/${tournamentId}`);
            const tData = await tRes.json();
            setTournament(tData);

            const gRes = await authenticatedFetch(`/tournaments/${tournamentId}/groups`);
            const gData = await gRes.json();
            const formatted = [];
            for (const cid in gData) {
                for (const rn in gData[cid]) {
                    for (const gn in gData[cid][rn]) {
                        formatted.push({ id: `${cid}-${rn}-${gn}`, name: `Group ${gn}`, courseId: parseInt(cid), roundNumber: parseInt(rn), players: gData[cid][rn][gn] });
                    }
                }
            }
            setGroups(formatted);
        } catch (e) { console.error(e); }
    };

    const handleSaveGroups = async () => {
        const toSave = {};
        groups.forEach(g => {
            if (!toSave[g.courseId]) toSave[g.courseId] = {};
            if (!toSave[g.courseId][g.roundNumber]) toSave[g.courseId][g.roundNumber] = {};
            toSave[g.courseId][g.roundNumber][g.id.split('-')[2]] = g.players.map(p => p.id);
        });
        const res = await authenticatedFetch(`/tournaments/${tournamentId}/groups`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(toSave) });
        if (res.ok) notify.success('Groups saved');
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => { fetchTournamentAndGroups(); }, [tournamentId]);

    useEffect(() => {
        if (tournament) {
            const groupedIds = groups.filter(g => g.roundNumber === selectedRound).flatMap(g => g.players.map(p => p.id));
            setUngroupedPlayers(tournament.players.filter(p => !groupedIds.includes(p.id)));
        }
    }, [tournament, groups, selectedRound]);

    const handleAddPlayerToGroup = (player) => {
        const c = tournament.courses.find(x => x.sequence_number === selectedRound);
        if (!c) return;
        const max = tournament.format?.toLowerCase() === 'singles matchplay' ? 2 : 4;
        const roundGroups = groups.filter(g => g.roundNumber === selectedRound && g.courseId === c.id).sort((a,b) => parseInt(a.id.split('-')[2]) - parseInt(b.id.split('-')[2]));
        let target = roundGroups.find(g => g.players.length < max);
        if (target) { target.players.push(player); setGroups([...groups]); }
        else {
            const num = roundGroups.length > 0 ? Math.max(...roundGroups.map(g => parseInt(g.id.split('-')[2]))) + 1 : 1;
            setGroups([...groups, { id: `${c.id}-${selectedRound}-${num}`, name: `Group ${num}`, courseId: c.id, roundNumber: selectedRound, players: [player] }]);
        }
    };

    return (
        <div className="groups-page">
            <header className="page-header"><h1>Groups</h1>{tournament && <h2>{tournament.name}</h2>}</header>
            <div className="groups-container">
                <select value={selectedRound} onChange={e => setSelectedRound(parseInt(e.target.value))}>{tournament?.courses.sort((a,b)=>a.sequence_number-b.sequence_number).map(c => <option key={c.sequence_number} value={c.sequence_number}>R{c.sequence_number} - {c.name}</option>)}</select>
                <div className="collapsible-section">
                    <h2 onClick={() => setOpenSections(p => ({...p, players: !p.players}))}>Players</h2>
                    {openSections.players && <div className="section-content">{ungroupedPlayers.map(p => <div key={p.id}>{p.name} <button onClick={()=>handleAddPlayerToGroup(p)}>+</button></div>)}</div>}
                </div>
                <div className="collapsible-section">
                    <h2 onClick={() => setOpenSections(p => ({...p, groups: !p.groups}))}>Groups</h2>
                    {openSections.groups && <div className="section-content">{groups.filter(g => g.roundNumber === selectedRound).map(g => <div key={g.id}><h3>{g.name}</h3><div>{g.players.map(p => <div key={p.id}>{p.name} <button onClick={()=>{g.players=g.players.filter(x=>x.id!==p.id); setGroups([...groups]);}}>-</button></div>)}</div></div>)}</div>}
                </div>
            </div>
            <div className="fixed-footer"><button onClick={() => navigate('/tournaments/add', { state: { tournament } })}>Back</button><button onClick={handleSaveGroups}>Save</button></div>
        </div>
    );
}

export default Groups;
